define([], function () {
  'use strict';

  return function () {
      (() => {
        if (window.location.hash.includes('reviews')) {
            document.querySelector('#reviews').style= '';
        }
      })();
  };
});
